<!-- <div class="container">

    <div *ngIf="allPartnerPros.length < 1">No Results for {{proType}} {{proYear}} {{proQuarter}}</div>

    <table mat-table matSort [dataSource]="dataSource" class="pro-partner-table" *ngIf="allPartnerPros.length > 0">

        <ng-container matColumnDef="position">
            <th class="position-header" mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
            <td class="position-cell" mat-cell *matCellDef="let element; let i = index"> {{i +
                1}} </td>
        </ng-container>

        <ng-container matColumnDef="year">
            <th class="year-header" mat-header-cell *matHeaderCellDef mat-sort-header> YEAR </th>
            <td class="year-cell" mat-cell *matCellDef="let element"> {{element.year}} </td>
        </ng-container>

        <ng-container matColumnDef="quarter">
            <th class="quarter-header" mat-header-cell *matHeaderCellDef mat-sort-header> QUARTER </th>
            <td class="quarter-cell" mat-cell *matCellDef="let element"> {{element.quarter}} </td>
        </ng-container>

        <ng-container matColumnDef="distributionYear">
            <th class="distribution-year-header" mat-header-cell *matHeaderCellDef mat-sort-header> DISTRIBUTION
                YEAR </th>
            <td class="distribution-year-cell" mat-cell *matCellDef="let element"> {{element.distributionYear}}
            </td>
        </ng-container>

        <ng-container matColumnDef="distributionQuarter">
            <th class="distribution-quarter-header" mat-header-cell *matHeaderCellDef mat-sort-header> DISTRIBUTION
                QUARTER </th>
            <td class="distribution-quarter-cell" mat-cell *matCellDef="let element">
                {{element.distributionQuarter}} </td>
        </ng-container>

        <ng-container matColumnDef="statementRecipientId">
            <th class="statement-recipient-id-header" mat-header-cell *matHeaderCellDef mat-sort-header> STATEMENT
                RECIPIENT ID </th>
            <td class="statement-recipient-id-cell" mat-cell *matCellDef="let element">
                {{element.statementRecipientId}} </td>
        </ng-container>

        <ng-container matColumnDef="statementRecipientName">
            <th class="statement-recipient-name-header" mat-header-cell *matHeaderCellDef mat-sort-header> STATEMENT
                RECIPIENT NAME </th>
            <td class="statement-recipient-name-cell" mat-cell *matCellDef="let element">
                {{element.statementRecipientName}} </td>
        </ng-container>

        <ng-container matColumnDef="partyId">
            <th class="party-id-header" mat-header-cell *matHeaderCellDef mat-sort-header> PARTY ID </th>
            <td class="party-id-cell" mat-cell *matCellDef="let element"> {{element.partyId}} </td>
        </ng-container>

        <ng-container matColumnDef="partyName">
            <th class="party-name-header" mat-header-cell *matHeaderCellDef mat-sort-header> PARTY NAME </th>
            <td class="party-name-cell" mat-cell *matCellDef="let element"> {{element.partyName}} </td>
        </ng-container>

        <ng-container matColumnDef="legalEarnerPartyId">
            <th class="legal-earner-party-id-header" mat-header-cell *matHeaderCellDef mat-sort-header> LEGAL EARNER
                PARTY ID </th>
            <td class="legal-earner-party-id-cell" mat-cell *matCellDef="let element">
                {{element.legalEarnerPartyId}} </td>
        </ng-container>

        <ng-container matColumnDef="legalEarnerPartyName">
            <th class="legal-earner-party-name-header" mat-header-cell *matHeaderCellDef mat-sort-header> LEGAL
                EARNER PARTY NAME </th>
            <td class="legal-earner-party-name-cell" mat-cell *matCellDef="let element">
                {{element.legalEarnerPartyName}} </td>
        </ng-container>

        <ng-container matColumnDef="performanceSource">
            <th class="performance-source-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE
                SOURCE </th>
            <td class="performance-source-cell" mat-cell *matCellDef="let element"> {{element.performanceSource}}
            </td>
        </ng-container>

        <ng-container matColumnDef="musicUserGenre">
            <th class="music-user-genre-header" mat-header-cell *matHeaderCellDef mat-sort-header> MUSIC USER GENRE
            </th>
            <td class="music-user-genre-cell" mat-cell *matCellDef="let element"> {{element.musicUserGenre}} </td>
        </ng-container>

        <ng-container matColumnDef="musicUser">
            <th class="music-user-header" mat-header-cell *matHeaderCellDef mat-sort-header> MUSIC USER </th>
            <td class="music-user-cell" mat-cell *matCellDef="let element"> {{element.musicUser}} </td>
        </ng-container>

        <ng-container matColumnDef="networkService">
            <th class="network-service-header" mat-header-cell *matHeaderCellDef mat-sort-header> NETWORK SERVICE
            </th>
            <td class="network-service-cell" mat-cell *matCellDef="let element"> {{element.networkService}} </td>
        </ng-container>

        <ng-container matColumnDef="performanceStartDate">
            <th class="performance-start-date-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE
                START DATE </th>
            <td class="performance-start-date-cell" mat-cell *matCellDef="let element">
                {{element.performanceStartDate}} </td>
        </ng-container>

        <ng-container matColumnDef="performanceEndDate">
            <th class="performance-end-date-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE
                END DATE </th>
            <td class="performance-end-date-cell" mat-cell *matCellDef="let element"> {{element.performanceEndDate}}
            </td>
        </ng-container>

        <ng-container matColumnDef="surveyType">
            <th class="survey-type-header" mat-header-cell *matHeaderCellDef mat-sort-header> SURVEY TYPE </th>
            <td class="survey-type-cell" mat-cell *matCellDef="let element"> {{element.serveyType}} </td>
        </ng-container>

        <ng-container matColumnDef="dayPartCode">
            <th class="day-part-code-header" mat-header-cell *matHeaderCellDef mat-sort-header> DAY PART CODE </th>
            <td class="day-part-code-cell" mat-cell *matCellDef="let element"> {{element.dayPartCode}} </td>
        </ng-container>

        <ng-container matColumnDef="show">
            <th class="show-header" mat-header-cell *matHeaderCellDef mat-sort-header> SHOW </th>
            <td class="show-cell" mat-cell *matCellDef="let element"> {{element.show?.name}} </td>
        </ng-container>

        <ng-container matColumnDef="episodeName">
            <th class="episode-name-header" mat-header-cell *matHeaderCellDef mat-sort-header> EPISODE NAME </th>
            <td class="episode-name-cell" mat-cell *matCellDef="let element"> {{element.episodeName}} </td>
        </ng-container>

        <ng-container matColumnDef="workId">
            <th class="work-id-header" mat-header-cell *matHeaderCellDef mat-sort-header> WORK ID </th>
            <td class="work-id-cell" mat-cell *matCellDef="let element"> {{element.workId}} </td>
        </ng-container>

        <ng-container matColumnDef="workTitle">
            <th class="work-title-header" mat-header-cell *matHeaderCellDef mat-sort-header> WORK TITLE </th>
            <td class="work-title-cell" mat-cell *matCellDef="let element"> {{element.workTitle}} </td>
        </ng-container>

        <ng-container matColumnDef="allocationPercentage">
            <th class="allocation-percentage-header" mat-header-cell *matHeaderCellDef mat-sort-header> ALLOCATION
                PERCENTAGE </th>
            <td class="allocation-percentage-cell" mat-cell *matCellDef="let element">
                {{element.allocationPercentage}} </td>
        </ng-container>

        <ng-container matColumnDef="classificationCode">
            <th class="classification-code-header" mat-header-cell *matHeaderCellDef mat-sort-header> CLASSIFICATION
                CODE </th>
            <td class="classification-code-cell" mat-cell *matCellDef="let element"> {{element.classificationCode}}
            </td>
        </ng-container>

        <ng-container matColumnDef="numberOfPlays">
            <th class="number-of-plays-header" mat-header-cell *matHeaderCellDef mat-sort-header> NUMBER OF PLAYS
            </th>
            <td class="number-of-plays-cell" mat-cell *matCellDef="let element"> {{element.numberOfPlays}} </td>
        </ng-container>

        <ng-container matColumnDef="performanceType">
            <th class="performance-type-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE TYPE
            </th>
            <td class="performance-type-cell" mat-cell *matCellDef="let element"> {{element.performanceType}} </td>
        </ng-container>

        <ng-container matColumnDef="duration">
            <th class="duration-header" mat-header-cell *matHeaderCellDef mat-sort-header> DURATION </th>
            <td class="duration-cell" mat-cell *matCellDef="let element"> {{element.duration}} </td>
        </ng-container>

        <ng-container matColumnDef="performingArtist">
            <th class="performing-artist-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMING
                ARTIST </th>
            <td class="performing-artist-cell" mat-cell *matCellDef="let element"> {{element.performingArtist}}
            </td>
        </ng-container>

        <ng-container matColumnDef="composerName">
            <th class="composer-name-header" mat-header-cell *matHeaderCellDef mat-sort-header> COMPOSER NAME </th>
            <td class="composer-name-cell" mat-cell *matCellDef="let element"> {{element.composerName}} </td>
        </ng-container>

        <ng-container matColumnDef="eeShare">
            <th class="ee-share-header" mat-header-cell *matHeaderCellDef mat-sort-header> EE SHARE </th>
            <td class="ee-share-cell" mat-cell *matCellDef="let element"> {{element.eeShare}} </td>
        </ng-container>

        <ng-container matColumnDef="credits">
            <th class="credits-header" mat-header-cell *matHeaderCellDef mat-sort-header> CREDITS </th>
            <td class="credits-cell" mat-cell *matCellDef="let element"> {{element.credits}} </td>
        </ng-container>

        <ng-container matColumnDef="royalty">
            <th class="royalty-header" mat-header-cell *matHeaderCellDef mat-sort-header> ROYALTY </th>
            <td class="royalty-cell" mat-cell *matCellDef="let element"> {{element.royalty}} </td>
        </ng-container>

        <ng-container matColumnDef="premiumCredits">
            <th class="premium-credits-header" mat-header-cell *matHeaderCellDef mat-sort-header> PREMIUM CREDITS
            </th>
            <td class="premium-credits-cell" mat-cell *matCellDef="let element"> {{element.premiumCredits}} </td>
        </ng-container>

        <ng-container matColumnDef="premiumRoyalty">
            <th class="premium-royalty-header" mat-header-cell *matHeaderCellDef mat-sort-header> PREMIUM ROYALTY
            </th>
            <td class="premium-royalty-cell" mat-cell *matCellDef="let element"> {{element.premiumRoyalty}} </td>
        </ng-container>

        <ng-container matColumnDef="adjustmentIndicator">
            <th class="adjustment-indicator-header" mat-header-cell *matHeaderCellDef mat-sort-header> ADJUSTMENT
                INDICATOR </th>
            <td class="adjustment-indicator-cell" mat-cell *matCellDef="let element">
                {{element.adjustmentIndicator}} </td>
        </ng-container>

        <ng-container matColumnDef="adjustmentReasonCode">
            <th class="adjustment-reason-code-header" mat-header-cell *matHeaderCellDef mat-sort-header> ADJUSTMENT
                REASON CODE </th>
            <td class="adjustment-reason-code-cell" mat-cell *matCellDef="let element">
                {{element.adjustmentReasonCode}} </td>
        </ng-container>

        <ng-container matColumnDef="originalDistributionDate">
            <th class="original-distribution-date-header" mat-header-cell *matHeaderCellDef mat-sort-header>
                ORIGINAL DISTRIBUTION DATE </th>
            <td class="original-distribution-date-cell" mat-cell *matCellDef="let element">
                {{element.originalDistributionDate}} </td>
        </ng-container>

        <ng-container matColumnDef="roleType">
            <th class="role-type-header" mat-header-cell *matHeaderCellDef mat-sort-header> ROLE TYPE </th>
            <td class="role-type-cell" mat-cell *matCellDef="let element"> {{element.roleType}} </td>
        </ng-container>

        <ng-container matColumnDef="typeOfRight">
            <th class="type-of-right-header" mat-header-cell *matHeaderCellDef mat-sort-header> TYPE OF RIGHT </th>
            <td class="type-of-right-cell" mat-cell *matCellDef="let element"> {{element.typeOfRight}} </td>
        </ng-container>

        <ng-container matColumnDef="territory">
            <th class="territory-header" mat-header-cell *matHeaderCellDef mat-sort-header> TERRITORY </th>
            <td class="territory-cell" mat-cell *matCellDef="let element"> {{element.territory}} </td>
        </ng-container>

        <ng-container matColumnDef="licensor">
            <th class="licensor-header" mat-header-cell *matHeaderCellDef mat-sort-header> LICENSOR </th>
            <td class="licensor-cell" mat-cell *matCellDef="let element"> {{element.licensor}} </td>
        </ng-container>

        <ng-container matColumnDef="programCode">
            <th class="program-code-header" mat-header-cell *matHeaderCellDef mat-sort-header> PROGRAM CODE </th>
            <td class="program-code-cell" mat-cell *matCellDef="let element"> {{element.programCode}} </td>
        </ng-container>

        <ng-container matColumnDef="performanceQuarter">
            <th class="performance-quarter-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE
                QUARTER </th>
            <td class="performance-quarter-cell" mat-cell *matCellDef="let element"> {{element.performanceQuarter}}
            </td>
        </ng-container>

        <ng-container matColumnDef="countryName">
            <th class="country-name-header" mat-header-cell *matHeaderCellDef mat-sort-header> COUNTRY NAME </th>
            <td class="country-name-cell" mat-cell *matCellDef="let element"> {{element.countryName}} </td>
        </ng-container>

        <ng-container matColumnDef="fileType">
            <th class="file-type-header" mat-header-cell *matHeaderCellDef mat-sort-header> FILE TYPE </th>
            <td class="file-type-cell" mat-cell *matCellDef="let element"> {{element.fileType}} </td>
        </ng-container>

        <ng-container matColumnDef="licensorCode">
            <th class="licensor-code-header" mat-header-cell *matHeaderCellDef mat-sort-header> LICENSOR CODE </th>
            <td class="licensor-code-cell" mat-cell *matCellDef="let element"> {{element.licensorCode}} </td>
        </ng-container>

        <ng-container matColumnDef="revenueClassCode">
            <th class="revenue-class-code-header" mat-header-cell *matHeaderCellDef mat-sort-header> REVENUE CLASS
                CODE </th>
            <td class="revenue-class-code-cell" mat-cell *matCellDef="let element"> {{element.revenueClassCode}}
            </td>
        </ng-container>

        <ng-container matColumnDef="revenueClassDescription">
            <th class="revenue-class-description-header" mat-header-cell *matHeaderCellDef mat-sort-header> REVENUE
                CLASS DESCRIPTION </th>
            <td class="revenue-class-description-cell" mat-cell *matCellDef="let element">
                {{element.revenueClassDescription}} </td>
        </ng-container>

        <ng-container matColumnDef="adjustmentDistributionDate">
            <th class="adjustment-distribution-date-header" mat-header-cell *matHeaderCellDef mat-sort-header>
                ADJUSTMENT DISTRIBUTION DATE </th>
            <td class="adjustment-distribution-date-cell" mat-cell *matCellDef="let element">
                {{element.adjustmentDistributionDate}} </td>
        </ng-container>

        <ng-container matColumnDef="currentActivityAmt">
            <th class="current-activity-amt-header" mat-header-cell *matHeaderCellDef mat-sort-header> CURRENT
                ACTIVITY AMOUNT </th>
            <td class="current-activity-amt-cell" mat-cell *matCellDef="let element"> {{element.currentActivityAmt}}
            </td>
        </ng-container>

        <ng-container matColumnDef="hitSongBonus">
            <th class="hit-song-bonus-header" mat-header-cell *matHeaderCellDef mat-sort-header> HIT SONG BONUS
            </th>
            <td class="hit-song-bonus-cell" mat-cell *matCellDef="let element"> {{element.hitSongBonus}} </td>
        </ng-container>

        <ng-container matColumnDef="standardsBonus">
            <th class="standards-bonus-header" mat-header-cell *matHeaderCellDef mat-sort-header> STANDARDS BONUS
            </th>
            <td class="standards-bonus-cell" mat-cell *matCellDef="let element"> {{element.standardsBonus}} </td>
        </ng-container>

        <ng-container matColumnDef="foreignSocietyAdjustment">
            <th class="foreign-society-adjustment-header" mat-header-cell *matHeaderCellDef mat-sort-header> FOREIGN
                SOCIETY ADJUSTMENT </th>
            <td class="foreign-society-adjustment-cell" mat-cell *matCellDef="let element">
                {{element.foreignSocietyAdjustment}} </td>
        </ng-container>

        <ng-container matColumnDef="perfDate">
            <th class="perf-date-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE DATE </th>
            <td class="perf-date-cell" mat-cell *matCellDef="let element"> {{element.perfDate}} </td>
        </ng-container>

        <ng-container matColumnDef="wOrP">
            <th class="w-or-d-header" mat-header-cell *matHeaderCellDef mat-sort-header> W OR P </th>
            <td class="w-or-d-cell" mat-cell *matCellDef="let element"> {{element.wOrP}} </td>
        </ng-container>

        <ng-container matColumnDef="showName">
            <th class="album-title-header" mat-header-cell *matHeaderCellDef mat-sort-header> SHOW NAME </th>
            <td class="album-title-cell" mat-cell *matCellDef="let element"> {{element.showName}} </td>
        </ng-container>

        <ng-container matColumnDef="paymentType">
            <th class="payment-type-header" mat-header-cell *matHeaderCellDef mat-sort-header> PAYMENT TYPE </th>
            <td class="payment-type-cell" mat-cell *matCellDef="let element"> {{element.paymentType}} </td>
        </ng-container>

        <ng-container matColumnDef="chart">
            <th class="chart-header" mat-header-cell *matHeaderCellDef mat-sort-header> CHART </th>
            <td class="chart-cell" mat-cell *matCellDef="let element"> {{element.chart}} </td>
        </ng-container>

        <ng-container matColumnDef="payNumber">
            <th class="pay-number-header" mat-header-cell *matHeaderCellDef mat-sort-header> PAY NUMBER </th>
            <td class="pay-number-cell" mat-cell *matCellDef="let element"> {{element.payNumber}} </td>
        </ng-container>

        <ng-container matColumnDef="synd">
            <th class="synd-header" mat-header-cell *matHeaderCellDef mat-sort-header> SYND </th>
            <td class="synd-cell" mat-cell *matCellDef="let element"> {{element.synd}} </td>
        </ng-container>

        <ng-container matColumnDef="strip">
            <th class="strip-header" mat-header-cell *matHeaderCellDef mat-sort-header> STRIP </th>
            <td class="strip-cell" mat-cell *matCellDef="let element"> {{element.strip}} </td>
        </ng-container>

        <ng-container matColumnDef="performance">
            <th class="performance-header" mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE </th>
            <td class="performance-cell" mat-cell *matCellDef="let element"> {{element.performance}} </td>
        </ng-container>

        <ng-container matColumnDef="occur">
            <th class="occur-header" mat-header-cell *matHeaderCellDef mat-sort-header> OCCUR </th>
            <td class="occur-cell" mat-cell *matCellDef="let element"> {{element.occur}} </td>
        </ng-container>

        <ng-container matColumnDef="societyAbbrv">
            <th class="society-abbrv-header" mat-header-cell *matHeaderCellDef mat-sort-header> SOCIETY ABBRV </th>
            <td class="society-abbrv-cell" mat-cell *matCellDef="let element"> {{element.socidetyAbbrv}} </td>
        </ng-container>

        <ng-container matColumnDef="societyCountry">
            <th class="society-country-header" mat-header-cell *matHeaderCellDef mat-sort-header> SOCIETY COUNTRY
            </th>
            <td class="society-country-cell" mat-cell *matCellDef="let element"> {{element.societyCountry}} </td>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="data-row"></mat-row>
    </table>
</div> -->


<!-- STANDARD HTML TABLE APPROACH - START -->
<div class="container">

    <div *ngIf="allPartnerPros.length < 1 && loading == false && partnerService.getCurrentValue() == true" class="pro-loader">No Results for {{proType}} {{proYear}} {{proQuarter}}</div>

    <div *ngIf="loading" class="pro-loader">
        <app-loader color="#50e3c2"></app-loader>
    </div>

    <div class="table-container" #scrollContainer (scroll)="onScroll($event)">
        <table class="pro-table" *ngIf="allPartnerPros.length > 0">
            <tr class="header-row">
                <th *ngFor="let col of columns" class="column-headers" (click)="getPros(col)">{{col.value}}</th>
            </tr>
            <tr *ngFor="let row of allPartnerPros; let i = index" class="data-row">
                <td class="position-cell">{{(tablePage - 1) * tablePageSize + i + 1}}</td>
                <td>{{row.year}}</td>
                <td>{{row.quarter}}</td>
                <td *ngIf="checkColumns('DISTRIBUTION YEAR')">{{row.distributionYear}}</td>
                <td *ngIf="checkColumns('DISTRIBUTION QUARTER')">{{row.distributionQuarter}}</td>
                <td *ngIf="checkColumns('STATEMENT RECIPIENT ID')">{{row.statementRecipientId}}</td>
                <td *ngIf="checkColumns('STATEMENT RECIPIENT NAME')">{{row.statementRecipientName}}</td>
                <td *ngIf="checkColumns('PARTY ID')">{{row.partyId}}</td>
                <td *ngIf="checkColumns('PARTY NAME')">{{row.partyName}}</td>
                <td *ngIf="checkColumns('LEGAL EARNER PARTY ID')">{{row.legalEarnerPartyId}}</td>
                <td *ngIf="checkColumns('LEGAL EARNER PARTY NAME')">{{row.legalEarnerPartyName}}</td>
                <td *ngIf="checkColumns('PERFORMANCE SOURCE')">{{row.performanceSource}}</td>
                <td *ngIf="checkColumns('MUSIC USER GENRE')">{{row.musicUserGenre}}</td>
                <td *ngIf="checkColumns('MUSIC USER')">{{row.musicUser}}</td>
                <td *ngIf="checkColumns('NETWORK SERVICE')">{{row.networkService}}</td>
                <td *ngIf="checkColumns('PERFORMANCE START DATE')">{{row.performanceStartDate | date}}</td>
                <td *ngIf="checkColumns('PERFORMANCE END DATE')">{{row.performanceEndDate | date}}</td>
                <td *ngIf="checkColumns('SURVEY TYPE')">{{row.surveyType}}</td>
                <td *ngIf="checkColumns('DAY PART CODE')">{{row.dayPartCode}}</td>
                <td *ngIf="checkColumns('SERIES OR FILM/ATTRACTION')">{{row.show?.name}}</td> <!-- Assuming 'show' has a 'name' property -->
                <td *ngIf="checkColumns('PROGRAM/EPISODE NAME')">{{row.episodeName}}</td>
                <td *ngIf="checkColumns('WORK ID')">{{row.workId}}</td>
                <td *ngIf="checkColumns('WORK TITLE')">{{row.workTitle}}</td>
                <td *ngIf="checkColumns('CA%')">{{row.allocationPercentage}}</td>
                <td *ngIf="checkColumns('CLASSIFICATION CODE')">{{row.classificationCode}}</td>
                <td *ngIf="checkColumns('NUMBER OF PLAYS')">{{row.numberOfPlays}}</td>
                <td *ngIf="checkColumns('PERFORMANCE TYPE')">{{row.performanceType}}</td>
                <td *ngIf="checkColumns('DURATION')">{{row.duration}}</td>
                <td *ngIf="checkColumns('PERFORMING ARTIST')">{{row.performingArtist}}</td>
                <td *ngIf="checkColumns('COMPOSER NAME')">{{row.composerName}}</td>
                <td *ngIf="checkColumns('EE SHARE')">{{row.eeShare}}</td>
                <td *ngIf="checkColumns('CREDITS')">{{row.credits}}</td>
                <td *ngIf="checkColumns('USD')">{{row.royalty}}</td>
                <td *ngIf="checkColumns('%USD')">{{row.adj_usd}}</td>
                <td *ngIf="checkColumns('PREMIUM CREDITS')">{{row.premiumCredits}}</td>
                <td *ngIf="checkColumns('PREMIUM ROYALTY')">{{row.premiumRoyalty}}</td>
                <td *ngIf="checkColumns('ADJUSTMENT INDICATOR')">{{row.adjustmentIndicator}}</td>
                <td *ngIf="checkColumns('ADJUSTMENT REASON CODE')">{{row.adjustmentReasonCode}}</td>
                <td *ngIf="checkColumns('ORIGINAL DISTRIBUTION DATE')">{{row.originalDistributionDate | date}}</td>
                <td *ngIf="checkColumns('ROLE TYPE')">{{row.roleType}}</td>
                <td *ngIf="checkColumns('TYPE OF RIGHT')">{{row.typeOfRight}}</td>
                <td *ngIf="checkColumns('TERRITORY')">{{row.territory}}</td>
                <td *ngIf="checkColumns('LICENSOR')">{{row.licensor}}</td>
                <td *ngIf="checkColumns('PROGRAM CODE')">{{row.programCode}}</td>
                <td *ngIf="checkColumns('PERFORMANCE QUARTER')">{{row.performanceQuarter}}</td>
                <td *ngIf="checkColumns('COUNTRY NAME')">{{row.countryName}}</td>
                <td *ngIf="checkColumns('FILE TYPE')">{{row.fileType}}</td>
                <td *ngIf="checkColumns('LICENSOR CODE')">{{row.licensorCode}}</td>
                <td *ngIf="checkColumns('REVENUE CLASS CODE')">{{row.revenueClassCode}}</td>
                <td *ngIf="checkColumns('REVENUE CLASS DESCRIPTION')">{{row.revenueClassDescription}}</td>
                <td *ngIf="checkColumns('ADJUSTMENT DISTRIBUTION DATE')">{{row.adjustentDistributionDate | date}}</td>
                <td *ngIf="checkColumns('CURRENT ACTIVITY AMOUNT')">{{row.currentActivityAmt}}</td>
                <td *ngIf="checkColumns('HIT SONG BONUS')">{{row.hitSongBonus}}</td>
                <td *ngIf="checkColumns('STANDARDS BONUS')">{{row.standardsBonus}}</td>
                <td *ngIf="checkColumns('FOREIGN SOCIETY ADJUSTMENT')">{{row.foreignSocietyAdjustment}}</td>
                <td *ngIf="checkColumns('PERFORMANCE DATE')">{{row.perfDate | date}}</td>
                <td *ngIf="checkColumns('W OR P')">{{row.wOrP}}</td>
                <td *ngIf="checkColumns('SHOW NAME')">{{row.showName}}</td>
                <td *ngIf="checkColumns('PAYMENT TYPE')">{{row.paymentType}}</td>
                <td *ngIf="checkColumns('CHART')">{{row.chart}}</td>
                <td *ngIf="checkColumns('PAY NUMBER')">{{row.payNumber}}</td>
                <td *ngIf="checkColumns('SYND')">{{row.synd}}</td>
                <td *ngIf="checkColumns('STRIP')">{{row.strip}}</td>
                <td *ngIf="checkColumns('PERFORMANCE')">{{row.performance}}</td>
                <td *ngIf="checkColumns('OCCUR')">{{row.occur}}</td>
                <td *ngIf="checkColumns('SOCIETY ABBRV')">{{row.socidetyAbbrv}}</td>
                <td *ngIf="checkColumns('SOCIETY COUNTRY')">{{row.societyCountry}}</td>
            </tr>
        </table>
    </div>
    <app-custom-scroll-bar [scrollContainer]="scrollContainerRef.nativeElement" *ngIf="allPartnerPros.length > 0"></app-custom-scroll-bar>

    <app-custom-pagination *ngIf="allPartnerPros.length > 0" [data]="tableData"></app-custom-pagination>

</div>
<!-- STANDARD HTML TABLE APPROACH - END --> 